import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  loadingToggleAction,
  loginProAction,
} from "../../store/actions/AuthActions";

// image
//import logo from "../../images/logo-full-white.png";
import loginbg from "./../../images/banner.jpg";

import logo2 from "./../../images/Site2.png";
import { Link } from "react-router-dom";

function Login(props) {
  const [email, setEmail] = useState("user@gmail.com");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("12345678");

  const dispatch = useDispatch();

  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));
    dispatch(loginProAction(email, password, props.history));
  }
  const loadering = useSelector((state) => state.auth);
  console.log(loadering, "loader");
  return (
    <>
      {loadering.showLoading === true ? <div className="loader"></div> : null}
      <div className="page-wraper">
        <div
          className="page-content bg-white login-style2"
          style={{
            backgroundImage: "url(" + loginbg + ")",
            backgroundSize: "cover",
          }}
        >
          <div className="section-full">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-6 ">
                  <div className="text-white  align-self-center">
                    <div className="logo">
                      <img src={logo2} alt="" width={"100%"} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="login-2 submit-resume p-a30 seth">
                    <div className="nav">
                      <form onSubmit={onLogin} className="col-12 p-a0 ">
                        <p className="font-weight-600">
                          If you have an account with us, please log in.
                        </p>

                        {props.successMessage && (
                          <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                            {props.successMessage}
                          </div>
                        )}
                        <div className="form-group ">
                          <label>E-Mail Address*</label>
                          <div className="input-group">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Type Your Email Address"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <br />
                          {errors.email && (
                            <div className="text-danger fs-12">
                              {errors.email}
                            </div>
                          )}
                        </div>
                        <div className="form-group">
                          <label>Password *</label>
                          <div className="input-group">
                            <input
                              type="password"
                              className="form-control"
                              value={password}
                              placeholder="Type Your Password"
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                          <br />
                          {errors.password && (
                            <div className="text-danger fs-12">
                              {errors.password}
                            </div>
                          )}
                        </div>
                        <div className="text-center d-flex justify-content-between">
                        <button className="site-button float-left">
                            <Link
                              to={"/Professional-Signup"}
                              className="site-button py-1"
                            >
                              <i className="fa fa-user"></i>&nbsp;
                              signUp
                            </Link>
                          </button>
                          <button className="site-button float-left">
                            Login
                          </button>
                       
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="login-footer">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <span className="float-left">
                    © Copyright by &nbsp;
                    <a href="https://www.hnhtechsolutions.com/">
                      HnH Tech Solutions{" "}
                    </a>{" "}
                  </span>
                  <span className="float-right">All rights reserved.</span>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
